/**
 * The product's name and home, in one place.
 *
 * Everything in code that says the name or the production origin reads it from `brand.json`, so a
 * rename is an edit to that file plus the handful of static files `pnpm brand:audit` lists (the web
 * manifest, the favicon labels, the locale files' `app.name`, wrangler's vars, the docs). The audit
 * fails the build when a new hard-coded copy appears anywhere else. See docs/renaming.md.
 */
import brand from "./brand.json";

export const BRAND: {
  readonly name: string;
  readonly storagePrefix: string;
  readonly productionOrigin: string;
} = brand;

/** Host part of the production origin, for places that print it without a scheme. */
export const PRODUCTION_HOST = new URL(BRAND.productionOrigin).host;

/** A browser-storage key in the product's namespace: `storageKey("prefs")` → "<prefix>.prefs". */
export function storageKey(suffix: string): string {
  return `${BRAND.storagePrefix}.${suffix}`;
}
